import { render } from "./CloseOutReport.vue?vue&type=template&id=ca0aa87e"
import script from "./CloseOutReport.vue?vue&type=script&lang=js"
export * from "./CloseOutReport.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vannakpanha/Documents/Herd/peng-vannak-loan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__